import { defineStore } from 'pinia'
import axios from 'axios'

import type { ScopeResponse } from '@/model/settings'

export const useTenantScopesStore = defineStore('TenantScopesStore', () => {
  const tenantScopes: ScopeResponse[] = []
  const tenantScopeMap: Record<ScopeResponse['id'], ScopeResponse['name']> = {}
  const tenantScopeInverseMap: Record<ScopeResponse['name'], ScopeResponse['id']> = {}

  let loaded = false

  /* This is called by authenticationGuard.ts after a user logs in, so we don't
     need to worry about it later whenever the store is used. */
  async function loadTenantScopes() {
    if (loaded) return
    const { data: scopes } = await axios.get('/v1/apikeys/scopes')
    for (const scope of scopes) {
      tenantScopeMap[scope.id] = scope.name
      tenantScopeInverseMap[scope.name] = scope.id
      tenantScopes.push(scope)
    }
    loaded = true
  }

  return {
    loadTenantScopes,
    tenantScopes,
    tenantScopeMap,
    tenantScopeInverseMap,
  }
})
